'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AppItem", {
    enumerable: true,
    get: function() {
        return AppItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useAppItem = require("./useAppItem");
const _renderAppItem = require("./renderAppItem");
const _useAppItemStylesstyles = require("./useAppItemStyles.styles");
const AppItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useAppItem.useAppItem_unstable)(props, ref);
    (0, _useAppItemStylesstyles.useAppItemStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useAppItemStyles_unstable')(state);
    return (0, _renderAppItem.renderAppItem_unstable)(state);
});
AppItem.displayName = 'AppItem';
